<template>
  <div>
    <!-- <button class="mpbtn">打开腾慧直播小程序</button> -->
    <div v-if="!isWeixin" style="text-align:center;padding-top:20px;">
      请在微信浏览器中打开
    </div>
    <template v-else>
      <wx-open-launch-weapp
        id="launch-btn"
        username="gh_691c02fc94f9"
        :path="pathData"
      >
        <script type="text/wxtag-template">
              <style>.mpbtn {
                      padding: 12px;
                      display: block;
                      background: #409eff;
                      margin: auto;
                      border: none;
                      border-radius: 10px;
                      color: #ffffff;
                      margin-top: 40px;
                      width: 320px;
                      margin-left:50px;
                    }</style>
               <button class="mpbtn">打开腾慧直播小程序</button>
        </script>
      </wx-open-launch-weapp>
    </template>
  </div>
</template>

<script>
import tool from "../../kits/Tools.js";
export default {
  data() {
    return {
      share: {},
      pathData: "",
      ds_id: "",
      isWeixin: true,
    };
  },
  mounted() {
    this.shareToWeChat();
    // pqIRxDsAj89/V5lVJADLXDMZkkVioyrEFuM9QibeWJ5WGAiCqnEezz2fpo1G5rRd7do3/MNnVrBNWiJJDdeG2xmS6ORfgUvRdmdK/i2Ksnw=

    this.ds_id = tool.getQueryDsId();
    this.isWeixin = tool.isWeixin();
    let that = this;
    //获取直播间信息
    tool.getDsInfo(function(dsInFo) {
      // 加载微信分享参数
      tool.login(dsInFo.direct_seeding.appid, function(userInfo) {
        that.personDataInit(userInfo, dsInFo);
      });
    });
  },
  methods: {
    personDataInit(fans, dsInfo) {
      //获取用户信息
      var that = this;
      this.pathData = `pages/liveRoom/liveRoom?ds_id=${this.ds_id}&token=${fans.token}`;

      //重缓存中获取数据
      // this.fans = fans;
      // this.fans_id = this.fans.fans_id;
      // this.headerUrl = this.fans.header;

      // this.checkIsAuth();

      // var queryData = tool.getQueryData(location.href);
      // var hasToken = false;
      // if(queryData.token !== "" && queryData.token){
      //   hasToken = true;
      // }
      // var otherLogin = getQueryString('other');
      //替换邀请码
      // if ((this.user != this.fans_id && this.fans_id && this.fans.token) || (this.isIOS && this.isWeixin && !hasToken && !otherLogin)) {
      //   var data = tool.getQueryData(location.href);
      //   data.fromuser = this.fans_id;
      //   if(this.isIOS && this.isWeixin && !otherLogin){
      //     data.token = this.fans.token;
      //   }
      //   if (tool.checkPhoneType() == 2) {
      //     const url = tool.getUrlAddQuery(
      //         window.location.pathname,
      //         data
      //       );
      //     window.history.replaceState({}, "除去URL参数", url);
      //   }else{
      //     const url = tool.getUrlAddQuery(
      //         window.location.protocol + "//" + window.location.host + window.location.pathname,
      //         data
      //       );
      //     window.location.href = url;
      //   }
      // }

      // 上报邀请数据
      // if(this.user && this.fans_id){
      //   this.invite();
      // }

      // 加载微信分享参数
      that.shareToWeChat();
      //获取直播间信息
      // this.loadAll(dsInfo);
    },
    shareToWeChat() {
      var that = this;
	  var option = "url=" + encodeURIComponent(location.href);
      this.axios
        .post(tool.baseUrl2() + "/init/getWechatShareData", option)
        .then(function(data) {
          var data = data.data;
          if (data.code == 200) {
            that.wxReady(data.data.shareData);
          }
        })
        .catch(function(data) {
          console.log("错误" + data);
        });
    },
    wxReady(params) {
      var that = this;

      //配置分享
      wx.config({
        debug: false,
        appId: params.appid, // 必填
        timestamp: params.timestamp, // 必填，生成签名的时间戳
        nonceStr: params.noncestr, // 必填，生成签名的随机串
        signature: params.signature, // 必填，签名，见附录1
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        openTagList: ["wx-open-launch-weapp"],
      });

      // this.share.url = params.url;
      // this.share.dec = that.initData.direct_seeding.desc;
      // this.share.title = that.initData.direct_seeding.name;
      // this.share.image = that.initData.direct_seeding.pic_url;
      // this.share.groupImage = that.initData.direct_seeding.pic_url;
      // this.share.groupDesc = that.initData.direct_seeding.name;

      // const funcList = this.initData.ds_func;

      // const shareItem = funcList.find((item) => {
      //   return item.module == "share";
      // });

      // if (shareItem) {
      //   this.share.dec = shareItem.params.friend_des;
      //   this.share.title = shareItem.params.friend_title;
      //   this.share.image = shareItem.params.friend_pic_url;
      //   this.share.groupImage = shareItem.params.moment_pic_url;
      //   this.share.groupDesc = shareItem.params.moment_des;
      // }

      // console.log("分享参数", this.share, params);

      // wx.ready(function() {
      //   //微信好友分享
      //   wx.updateAppMessageShareData({
      //     title: that.share.title, // 分享标题
      //     desc: that.share.dec, // 分享描述
      //     link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
      //     imgUrl: that.share.image, // 分享图标
      //     success: function() {
      //       console.log("设置分享微信好友分享参数成功");
      //     },
      //   });

      //   //微信朋友圈分享
      //   wx.updateTimelineShareData({
      //     title: that.share.groupDesc, // 分享标题
      //     link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
      //     imgUrl: that.share.groupImage, // 分享图标
      //     success: function() {
      //       console.log("设置分享微信朋友圈分享参数成功");
      //     },
      //   });
      // });
      wx.error(function(data) {
        console.log("错误");
        console.log(data);
      });
    },
  },
};
</script>

<style>
.mpbtn {
  padding: 12px;
  display: block;
  background: #409eff;
  margin: auto;
  border: none;
  border-radius: 10px;
  color: #ffffff;
  margin-top: 40px;
  width: 80%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// goWechat.vue?678bc3e0